export default __webpack_public_path__ + "static/media/addcircle.fcb81384.svg";